import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ConstantSumQuestion from "../ConstantSum";
import Matrix from "../Matrix";
import MutipleChoiceQuestion from "../MultipleChoiceQuestion";
import TextQuestion from "../TextQuestion";
import NumericQuestion from "../NumericQuestion";
import styles from './ModalSurveyQuestion.module.css';
import { useChartGridContext } from '../../contexts/ChartGridContext';
import { Snackbar, Alert } from "@mui/material";

const ModalSurveyQuestion = ({ surveyQuestionId, onCloseDialog }) => {

    const axiosPrivate = useAxiosPrivate();

    const [type, setType] = useState();
    const [responses, setResponses] = useState([]);
    const [question, setQuestion] = useState({});
    const [answerChoices, setAnswerChoices] = useState([]);
    const [statements, setStatements] = useState([]);
    const [questionNumber, setQuestionNumber] = useState(0);
    const [questionIsLoaded, setQuestionIsLoaded] = useState(false);
    const [alertStatus, setAlertStatus] = useState({
        open: false,
        severity: null,
        message: null,
    });

    const { updateChartResults } = useChartGridContext();

    const saveResponse = async (params) => {

        const json = { ...params };

        try {
            const response = await axiosPrivate.post(`/surveyQuestions/${surveyQuestionId}`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            console.log(`Response saved at ${(new Date().getTime())}`);
            setResponses(response.data.responses);
            updateChartResults(surveyQuestionId);
            setAlertStatus(prevState => ({
                ...prevState,
                severity: "success",
                message: "Response saved",
                open: true
            }));


        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {

        let isMounted = true;

        const controller = new AbortController();

        const getQuestion = async () => {

            try {
                const response = await axiosPrivate.get(`/surveyQuestions/${surveyQuestionId}`, {
                    signal: controller.signal
                });
                if (isMounted) {
                    setType(response.data.type);
                    setQuestionNumber(response.data.questionNumber);
                    setResponses(response.data.responses);
                    setQuestion(response.data.question);
                    setAnswerChoices(response.data.answerChoices);
                    setStatements(response.data.statements);
                    setQuestionIsLoaded(true);
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    // if (err.response?.status === 403) {
                    //     navigate('/login', { state: { from: location }, replace: true });
                    // }
                }
            }
        }

        getQuestion();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [surveyQuestionId]) // eslint-disable-line react-hooks/exhaustive-deps

    if (!questionIsLoaded) {
        return null;
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertStatus(prevState => ({
            ...prevState,
            open: false
        }));
    };


    console.log(`ModalSurveyQuestion.js rendering at ${(new Date().getTime())} surveyQuestionId: ${surveyQuestionId}`);

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.surveyQuestionContainer}>
                <ol className="title" style={{ maxWidth: "960px" }}>
                    <li value={questionNumber}>{question.text}</li>
                </ol>
                {(() => {
                    switch (type) {
                        case "matrix":
                            return <Matrix surveyQuestionId={question.surveyQuestionId} statements={statements} answerChoices={answerChoices} responses={responses} saveResponse={saveResponse} />
                        case "multiple choice":
                            return <MutipleChoiceQuestion question={question} answerChoices={answerChoices} responses={responses} saveResponse={saveResponse} />
                        case "text":
                            return <TextQuestion question={question} answerChoices={answerChoices} responses={responses} saveResponse={saveResponse} />
                        case "numeric":
                            return <NumericQuestion question={question} answerChoices={answerChoices} responses={responses} saveResponse={saveResponse} />
                        case "constant sum":
                            return <ConstantSumQuestion question={question} statements={statements} responses={responses} saveResponses={saveResponse} />
                        default:
                            return null
                    }
                })()}
                <button className="close" onClick={onCloseDialog}></button>
                <Snackbar open={alertStatus.open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <Alert onClose={handleClose} variant="filled" severity={alertStatus.severity} sx={{ width: '100%' }}>{alertStatus.message}</Alert>
                </Snackbar>
            </div>
        </div>
    );

};

export default ModalSurveyQuestion;
